/* NONYPE design system (revisão Apple 15/10/2026)
   1) :active funciona no iPhone (resposta no momento do toque)
   2) Carrossel de fotos do produto: a foto segue o dedo 1:1, pode ser pega no meio
      do movimento e para de trocar sozinha depois que a pessoa mexe. */
(() => {
  'use strict';

  document.addEventListener('touchstart', () => {}, { passive: true });

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SETTLE = 'transform .34s cubic-bezier(.22,.9,.3,1), opacity .34s ease';

  function initCarousel(original) {
    // Troca o elemento por uma cópia para soltar os eventos do script antigo da seção.
    const root = original.cloneNode(true);
    original.replaceWith(root);
    root.dataset.initialized = 'true';

    const viewport = root.querySelector('.nn-feature-carousel__viewport');
    const slides = [...root.querySelectorAll('[data-nn-feature-slide]')];
    const counter = root.querySelector('[data-nn-feature-current]');
    if (!viewport || slides.length < 2) return;

    let index = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    let timer = 0;
    let userTookOver = false;
    let visible = false;
    let drag = null;
    let settling = null;

    const wrap = (i) => (i + slides.length) % slides.length;
    const offsetOf = (el) => new DOMMatrixReadOnly(getComputedStyle(el).transform).m41 || 0;

    function clearInline(el) {
      el.style.transition = '';
      el.style.transform = '';
      el.style.opacity = '';
      el.style.visibility = '';
      el.style.zIndex = '';
    }

    function show(next) {
      index = wrap(next);
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (counter) counter.textContent = String(index + 1);
    }

    function stopAuto() {
      clearInterval(timer);
      timer = 0;
    }
    function startAuto() {
      stopAuto();
      if (userTookOver || reduceMotion || !visible || document.hidden) return;
      timer = setInterval(() => show(index + 1), 2500);
    }
    function takeOver() {
      userTookOver = true;
      stopAuto();
    }

    function place(offset) {
      const width = viewport.clientWidth || 1;
      const neighbor = offset < 0 ? wrap(index + 1) : wrap(index - 1);
      slides.forEach((slide, i) => {
        if (i === index) {
          slide.style.transition = 'none';
          slide.style.visibility = 'visible';
          slide.style.opacity = '1';
          slide.style.zIndex = '2';
          slide.style.transform = `translateX(${offset}px)`;
        } else if (i === neighbor && offset !== 0) {
          slide.style.transition = 'none';
          slide.style.visibility = 'visible';
          slide.style.opacity = '1';
          slide.style.zIndex = '1';
          slide.style.transform = `translateX(${offset + (offset < 0 ? width : -width)}px)`;
        } else {
          clearInline(slide);
        }
      });
      return neighbor;
    }

    function settle(offset, velocity) {
      const width = viewport.clientWidth || 1;
      // Decide pelo sentido e pela força do gesto, não só pela posição.
      const projected = offset + velocity * 180;
      const commit = Math.abs(projected) > width * 0.35;
      const neighbor = offset < 0 ? wrap(index + 1) : wrap(index - 1);
      const current = slides[index];
      const other = slides[neighbor];
      const target = commit ? (offset < 0 ? -width : width) : 0;

      current.style.transition = SETTLE;
      other.style.transition = SETTLE;
      current.style.transform = `translateX(${target}px)`;
      other.style.transform = `translateX(${target + (offset < 0 ? width : -width)}px)`;

      const done = () => {
        if (settling !== token) return;
        settling = null;
        slides.forEach(clearInline);
        if (commit) show(neighbor);
      };
      const token = { done, from: index, neighbor, commit };
      settling = token;
      current.addEventListener('transitionend', done, { once: true });
      setTimeout(done, 420);
    }

    viewport.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 || !event.isPrimary) return;
      takeOver();
      let base = 0;
      if (settling) {
        // Pegou no meio do movimento: continua de onde a foto está na tela.
        base = offsetOf(slides[settling.from]);
        settling = null;
        slides.forEach((s) => { s.style.transition = 'none'; });
      }
      drag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        base,
        offset: base,
        lastX: event.clientX,
        lastT: performance.now(),
        velocity: 0,
        active: base !== 0
      };
      if (drag.active) {
        root.classList.add('is-dragging');
        viewport.setPointerCapture?.(event.pointerId);
        place(base);
      }
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.active) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
        if (Math.abs(dx) < 8) return;
        drag.active = true;
        root.classList.add('is-dragging');
        viewport.setPointerCapture?.(event.pointerId);
      }
      const now = performance.now();
      const dt = Math.max(now - drag.lastT, 1);
      drag.velocity = drag.velocity * 0.4 + ((event.clientX - drag.lastX) / dt) * 0.6;
      drag.lastX = event.clientX;
      drag.lastT = now;
      drag.offset = drag.base + dx;
      place(drag.offset);
    });

    const end = (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const finished = drag;
      drag = null;
      root.classList.remove('is-dragging');
      if (!finished.active) return;
      const recent = performance.now() - finished.lastT < 100;
      settle(finished.offset, recent ? finished.velocity : 0);
    };
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    viewport.addEventListener('dragstart', (e) => e.preventDefault());

    root.querySelector('[data-nn-feature-prev]')?.addEventListener('click', () => { takeOver(); show(index - 1); });
    root.querySelector('[data-nn-feature-next]')?.addEventListener('click', () => { takeOver(); show(index + 1); });
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        visible = Boolean(entry?.isIntersecting);
        if (visible) startAuto(); else stopAuto();
      }, { threshold: 0.4 }).observe(root);
    } else {
      visible = true;
      startAuto();
    }
    document.addEventListener('visibilitychange', () => (document.hidden ? stopAuto() : startAuto()));
    show(index);
  }

  function boot() {
    document.querySelectorAll('[data-nn-feature-carousel]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
